export default {
  methods: {
    getBannerStatus(item) {
      const rightNow = +new Date();
      const startPublish = new Date(item.startPublish).getTime();
      const endPublish = new Date(item.endPublish).getTime();

      if (startPublish <= rightNow && rightNow <= endPublish) {
        return 'showing';
      }
      if (startPublish > rightNow) {
        return 'pending';
      }
      return 'ended';
    },
    getPendingDays(startPublish) {
      let start = startPublish;
      if (typeof (startPublish) === 'string') {
        start = new Date(startPublish);
      }
      const rightNow = +new Date();
      return Math.round((start - rightNow) / 86400000);
    },
    getTomorrow() {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow;
    },
    tryToMakeTimeMachine(startPublish, endPublish) {
      const start = new Date(startPublish).getTime();
      const end = new Date(endPublish).getTime();
      return end < start;
    },
  },
};
